import React, {Component} from 'react';
import {
  Layout,
  Card,
  SkeletonBodyText,
  ResourceList,
  TextStyle,
  ResourceItem,
  Badge,
  Button,
  TextField,
  ButtonGroup
} from '@shopify/polaris';
import {
  ArrowLeftMinor,
  ArrowRightMinor
} from '@shopify/polaris-icons';
import Container from 'components/Container';
import {getUsers} from 'api/user';

const styles = {
  iframe: {
    border: 'none',
    width: '100%',
    height: 1000
  }
}
class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: null,
      page: 0,
      input: '',
      search: '',
    };
  }

  componentDidMount() {
    getUsers(this.state.page, this.state.search).then(users => {
      this.setState({users});
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page || prevState.search !== this.state.search) {
      this.setState({users: null})
      getUsers(this.state.page, this.state.search).then(users => {
        this.setState({users});
      });
    }
  }

  onClickSearch = () => {
    if (!this.state.input) {
      alert("Please input search string");
    }
    this.setState({
      search: this.state.input,
      page: 0,
    })
  }

  reset = () => {
    this.setState({
      search: '',
      input: '',
      page: 0,
    });
  }

  render() {
    const { users } = this.state;
    return (
      <Container pageProps={{
        title: 'Codes',
        subtitle: `Showing users`,
        fullWidth: true,
        primaryAction: (
          <div style={{display: 'flex', gap: 12}}>
            <div style={{display: 'flex'}}>
              <TextField clearButton onClearButtonClick={this.reset} placeholder="Search users..." onChange={input => this.setState({input})} value={this.state.input} />
              <Button onClick={this.onClickSearch}>Search</Button>
            </div>
            <ButtonGroup>
              <Button disabled={!this.state.page} onClick={() => this.setState({page: this.state.page - 1})} icon={ArrowLeftMinor} />
              <Button disabled={!users || users.length < 100} onClick={() => this.setState({page: this.state.page + 1})} icon={ArrowRightMinor} />
            </ButtonGroup>
          </div>
        )
      }}>
        <React.Fragment>
          <Layout.Section>
            <Card sectioned>
              Showing page {this.state.page + 1}
              {
                users ? (
                  <ResourceList
                    resourceName={{singular: 'customer', plural: 'customers'}}
                    items={users}
                    renderItem={(user) => {
                      const {id, tokens} = user;
                      return (
                        <ResourceItem
                          id={id}
                          persistActions
                          shortcutActions={[{content: `Customer: ${id}`, external: true,  url: `https://mystery-grail.myshopify.com/admin/customers/${id}`}]}
                        >
                          <h3>
                            <TextStyle variation="strong">Tokens: {tokens}</TextStyle>
                          </h3>
                          {
                            user.codes && user.codes.length ? (
                              <div>
                                <strong>Codes:</strong>
                                <br />
                                {
                                  user.codes.map(code => (
                                    <Badge>{code.id} : {code.type} : {code.value}</Badge>
                                  ))
                                }
                              </div>
                            ) : null
                          }
                          {
                            user.products && user.products.length ? (
                              <div>
                                <strong>Products:</strong>
                                <br />
                                {
                                  user.products.map(product => (
                                    <Badge>{product.id} : {product.status}</Badge>
                                  ))
                                }
                              </div>
                            ) : null
                          }
                          <div>

                          </div>
                        </ResourceItem>
                      );
                    }}
                  />
                ) : <SkeletonBodyText />
              }
            </Card>
          </Layout.Section>

        </React.Fragment>
      </Container>
    );
  }
}
export default Users;
